export const buildAnalyticsParamsToPDP = (params: {
  product: any;
  itemListId?: string;
  itemListName?: string;
  index?: number;
}) => {
  const { product, itemListId, itemListName, index } = params;
  const isDigital =
    product?.isDigital ||
    product?.is_digital ||
    product?.originalMaterial?.isDigital;
  const itemListIdParam = isDigital ? 'digital_sampling' : itemListId;
  const itemListNameParam = isDigital ? 'digital sampling' : itemListName;

  const urlParams = [];
  if (itemListId) {
    urlParams.push(`itemListId=${itemListIdParam}`);
  }
  if (itemListName) {
    urlParams.push(`itemListName=${itemListNameParam}`);
  }
  urlParams.push(`index=${product?.gridIndex ?? product?.index ?? index}`);

  return urlParams.join('&');
};
